export function useUpgradePlanStep() {
  const currentStep = useState<number>('upgradePlanStep', () => 1);

  const setStep = (step: number) => {
    currentStep.value = step;
  };

  return {
    currentStep,
    setStep,
  };
}
